module.exports = __webpack_public_path__ + "media/packs/images/flags/WS-9a651eedba1351e85c79abc83a4e9793.png";